import React, { useState, useEffect } from 'react'
import { getLocation, getLocationHaveAll, getLocationZipcode } from '../../redux/actions/location'
import { startLoading, doneLoading } from '../../utils/loading'

export const locationZipcode = async () => {
  let expiresAt = JSON.parse(localStorage.getItem('location-zipcode_expires'))
  let isNotExpire = new Date().getTime() < expiresAt
  // console.log('isNotExpire', isNotExpire)
  const location = localStorage.getItem('location-zipcode')

  if (isNotExpire && location && location !== 'undefined' && typeof location !== 'undefined') {
    return JSON.parse(location)
  } else {
    return handleLocationZipCode()
  }
}

export const loadLocation = async () => {
  let expiresAt = JSON.parse(localStorage.getItem('location_expires'))
  let isNotExpire = new Date().getTime() < expiresAt
  const location = localStorage.getItem('location')

  if (isNotExpire && location && location !== 'undefined' && typeof location !== 'undefined') {
    return JSON.parse(location)
  } else {
    return handleLocation()
  }
}

export const loadLocationHaveAll = async () => {
  let expiresAt = JSON.parse(localStorage.getItem('location_all_expires'))
  let isNotExpire = new Date().getTime() < expiresAt
  const location = localStorage.getItem('location_all')

  if (isNotExpire && location && location !== 'undefined' && typeof location !== 'undefined') {
    return JSON.parse(location)
  } else {
    return handleLocationHaveAll()
  }
}

export const handleLocationZipCode = async () => {
  startLoading()
  try {
    const location = await getLocationZipcode()
    // console.log('location', location.model)
    localStorage.setItem('location-zipcode', JSON.stringify(location.model))
    localStorage.setItem('location-zipcode_expires', 60 * 60 * 1000 + new Date().getTime())
    doneLoading()
    return location.model
  } catch (e) {
    console.log('error', e)
  }
  doneLoading()
}

export const handleLocation = async () => {
  startLoading()
  try {
    const location = await getLocation()
    // console.log('location', JSON.stringify(location.model))
    localStorage.setItem('location', JSON.stringify(location.model))
    localStorage.setItem('location_expires', 60 * 60 * 1000 + new Date().getTime())
    doneLoading()
    return location.model
  } catch (e) {
    console.log('error', e)
  }
  doneLoading()
}

export const handleLocationHaveAll = async () => {
  startLoading()
  try {
    const location = await getLocationHaveAll()
    // console.log('location', JSON.stringify(location.model))
    localStorage.setItem('location_all', JSON.stringify(location.model))
    localStorage.setItem('location_all_expires', 60 * 60 * 1000 + new Date().getTime())
    doneLoading()
    return location.model
  } catch (e) {
    console.log('error', e)
  }
  doneLoading()
}

export function buildFilteredTree(data, values) {
  // recursive function สำหรับ node เดียว
  function traverse(node) {
    // ถ้า node นี้หรือ child ของมันมี value ที่ตรงกับ values → keep ไว้
    let matchedChildren = []

    if (Array.isArray(node.children)) {
      matchedChildren = node.children
        .map(traverse) // recursive ลงไปหา children
        .filter(Boolean) // ตัดพวกที่ไม่ match ออก
    }

    // ถ้า node นี้ match เอง หรือมีลูกที่ match
    if (values?.includes(node.value) || matchedChildren.length > 0) {
      return {
        name: node.label,
        children: matchedChildren,
      }
    }

    // ถ้าไม่ match อะไรเลย return null
    return null
  }

  // รองรับ root เป็น array หรือ object
  const roots = Array.isArray(data) ? data : [data]
  return roots.map(traverse).filter(Boolean)
}

export function buildFilteredTreeChild(data, values) {
  function traverse(node) {
    // ถ้า node นี้ match → return ทั้ง node พร้อมลูกทั้งหมดเลย
    if (values?.includes(node.value)) {
      return {
        name: node.label,
        children: (node.children || []).map((child) => ({
          name: child.label,
          children: child.children
            ? child.children.map((grand) => ({
                name: grand.label,
                children: grand.children || [],
              }))
            : [],
        })),
      }
    }

    // ถ้าไม่ match → ตรวจสอบลูกที่ match
    if (Array.isArray(node.children)) {
      const matchedChildren = node.children.map(traverse).filter(Boolean)

      if (matchedChildren.length > 0) {
        return {
          name: node.label,
          children: matchedChildren,
        }
      }
    }

    return null
  }

  const roots = Array.isArray(data) ? data : [data]
  return roots.map(traverse).filter(Boolean)
}

export function getLabelsWithParents(data, values) {
  const result = []

  function search(node, parentLabel = '') {
    const currentLabel = parentLabel ? `${parentLabel}/${node.label}` : node.label

    // ถ้า value ของ node อยู่ใน values → เก็บ label พร้อม parent
    if (values.includes(node.value)) {
      result.push(currentLabel)
    }

    // ถ้ามี children ให้ค้นต่อ
    if (Array.isArray(node.children)) {
      for (const child of node.children) {
        search(child, currentLabel)
      }
    }
  }

  // รองรับ root ที่เป็น array หรือ object
  if (Array.isArray(data)) {
    for (const item of data) search(item)
  } else {
    search(data)
  }

  return result
}
